import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  Card, CardTitle, FieldColumn, TwoColumns,
} from '../ds';
import { validateOptionalMinutes } from '../helpers';
import { VentilationPanel } from './illustrations/EcoIllustrations';
import { StepperField } from './StepperField';

const Title = styled(CardTitle)`
  margin-bottom: 18px;
`;

interface VentilationSectionProps {
  readOnly: boolean;
}

/** Ventilação inicial e final do Modo Eco simplificado, em minutos, num card próprio como no design. */
export function VentilationSection({ readOnly }: Readonly<VentilationSectionProps>): ReactElement {
  const { t } = useTranslation();
  const minutes = t('ecoSimplificadoMin');

  return (
    <Card data-testid="eco-simplificado-ventilacao">
      <Title>{t('ecoSimplificadoVentilacaoInicialFinal')}</Title>
      <TwoColumns $left="minmax(0, 340px)">
        <FieldColumn>
          <StepperField name="ventStart" label={t('inicio')} unit={minutes} limits={{ min: 0 }} validate={validateOptionalMinutes} disabled={readOnly} />
          <StepperField name="ventEnd" label={t('fim')} unit={minutes} limits={{ min: 0 }} validate={validateOptionalMinutes} disabled={readOnly} />
        </FieldColumn>
        <VentilationPanel />
      </TwoColumns>
    </Card>
  );
}
